import {BusEvent, Dispatcher, DispatcherPriority, EventBus} from 'dispatcher'
import {
  DIRECT_MESSAGE_TYPE,
  WS_CHAT_TYPE_VALUE,
  WS_DIRECT_MESSAGE_RECEIVE_DATA
} from 'ws'

export class ChatAdapterDispatcher extends Dispatcher<
  WS_DIRECT_MESSAGE_RECEIVE_DATA,
  undefined
> {
  protected consumable: boolean = true
  protected assignmentId?: string

  public criteria(
    event: BusEvent<WS_DIRECT_MESSAGE_RECEIVE_DATA, undefined>
  ): boolean {
    return (
      event.type === WS_CHAT_TYPE_VALUE &&
      event.data?.type === DIRECT_MESSAGE_TYPE &&
      event.data.meta.assignment._id === this.assignmentId &&
      event.data.data.metadata?.topic === undefined
    )
  }

  public notificationCriteria(
    event: BusEvent<WS_DIRECT_MESSAGE_RECEIVE_DATA, undefined>
  ): boolean {
    return (
      event.type === WS_CHAT_TYPE_VALUE &&
      event.data?.type === DIRECT_MESSAGE_TYPE &&
      event.data?.data?.senderId !== this.dispatcher.credentials?.userId
    ) //&& this.assignmentId === undefined
  }

  protected priority: DispatcherPriority = 'MEDIUM'

  protected static instance: ChatAdapterDispatcher

  static shared(eventBus: EventBus, assignmentId?: string) {
    if (!ChatAdapterDispatcher.instance) {
      ChatAdapterDispatcher.instance = new ChatAdapterDispatcher(eventBus)
    }
    if (assignmentId) {
      ChatAdapterDispatcher.instance.assignmentId = assignmentId
    }
    return ChatAdapterDispatcher.instance
  }

  public clearAssignmentId() {
    this.assignmentId = undefined
  }
}
